import { render } from "./ModalDialogContainer.vue?vue&type=template&id=ecad57dc"
import script from "./ModalDialogContainer.vue?vue&type=script&lang=js"
export * from "./ModalDialogContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__